import ListItemMixin from "../ListItemMixin";
import Roundable from "../../../mixins/Roundable";
import Sizeable from "../../../mixins/Sizeable";

export default {

    mixins: [ListItemMixin, Roundable, Sizeable],
}